import { Component, Input, OnInit } from '@angular/core';
import { LocalityInterface } from 'src/app/util/interfaces/locality';
import { SiteService } from './service/site.service';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { iacOptionInterface } from 'src/app/page_component_item/input-with-autocomplete/input-with-autocomplete.component';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { mspTableHeaderI } from 'src/app/page_component_item/msp-table/msp-table.component';

@Component({
	selector: 'register-form-site',
	templateUrl: './site.component.html',
	styleUrls: ['./site.component.scss'],
})
export class SiteComponent implements OnInit {
	labels: any = {
		lbl_location_cadastre_altere_site: 'Register a new site or change the name of an existing one',
		lbl_selecione_site: 'Select a website',
		lbl_geral_site: 'Site',
		lbl_gerar_novo_site: 'New site',
		lbl_geral_salvar: 'Save',
		lbl_salvo_com_sucesso: 'Saved successfully',
		lbl_geral_site_atualizado_sucesso: 'Site updated successfully',
		lbl_geral_location_campos_redefinidos: 'All fields have been cleared',
		lbl_geral_site_campos_vazios_atualizar: 'Fill in the empty fields or search for a site to update',
		lbl_geral_site_nome_existente: 'You already have a site with that name',
		"lbl_geral_site_desativado'": 'Site deactivated',
		lbl_geral_site_ativado: 'Site activated',
		lbl_geral_site_nao_pode_ser_desativado: 'The Site cannot be deactivated as it has a linked location',
		lbl_geral_sites: '',
	};

	searchHeader: mspTableHeaderI[] = [
		{ name: 'site', value: 'lbl_geral_sites', colType: 'text' },
		{ name: 'active', value: 'lbl_geral_ativo', colType: 'boolean' },
	];

	constructor(
		private siteService: SiteService,
		private notification: NotificationService,
		private LabelsService: LabelsService
	) {}

	isLoadingLabels = true;
	isUpdating = false;
	isDisabling = false;

	placeholder = '';
	clearValues = false;
	inputHeight = '';

	isButtonVisible: string | number;
	site = {} as LocalityInterface;
	customInterface: LocalityInterface = {
		id: undefined,
		site: '',
	};

	siteList: LocalityInterface[] = [];
	listSitesIAC: iacOptionInterface[] = [];
	isLoadingSites = true;

	ngOnInit() {
		this.LabelsService.getLabels().subscribe((labels) => {
			this.labels = labels;
			this.isLoadingLabels = false;
		});

		this.getAllSites();
	}

	//Get site
	getSite(id: string): void {
		this.customInterface.id = id;
		this.siteService.getSiteById(id).subscribe((data) => {
			this.customInterface.id = data.id;
			this.customInterface.site = data.site;
			this.isButtonVisible = data.activeSite;
		});
	}

	//Salvar um site
	saveSite() {
		if (this.isUpdating || this.isDisabling) return;
		this.isUpdating = true;

		if (this.customInterface.id === '') {
			this.siteService.postSite(this.customInterface).subscribe((data) => {
				if (data[0].status === 'error') {
					return this.notification.setNotificationMessage(this.labels.lbl_geral_site_nome_existente);
				} else {
					this.notification.setNotificationMessage(this.labels.lbl_salvo_com_sucesso);
					this.isLoadingSites = true;
					this.getAllSites();
				}
				this.isUpdating = false;
			});
		}
		if (this.customInterface.id || this.customInterface.id != '') {
			this.siteService.updateSite(this.customInterface).subscribe((data) => {
				if (data[0].status === 'error') {
					return this.notification.setNotificationMessage(this.labels.lbl_geral_site_nome_existente);
				} else {
					this.notification.setNotificationMessage(this.labels.lbl_geral_site_atualizado_sucesso);
					this.isLoadingSites = true;
					this.getAllSites();
				}
				this.isUpdating = false;
			});
		}
	}

	//Limpar Campos
	clearInputs(isNew: boolean) {
		this.customInterface = {
			id: isNew ? '' : undefined,
			site: '',
		};
	}

	//Validar Campos
	validateForm() {
		if (this.customInterface.site === '' || this.customInterface.site === null) {
			this.notification.setNotificationMessage(this.labels.lbl_geral_site_campos_vazios_atualizar);
			return false;
		} else {
			this.saveSite();
		}
	}

	getAllSites() {
		this.listSitesIAC = [];
		this.siteService.getAllSites().subscribe((res) => {
			this.siteList = res;
			for (const item of this.siteList) {
				const newIacOption: iacOptionInterface = {
					name: item.site,
					value: item.id,
					commonGroup: item.active === 1 ? this.labels.lbl_geral_ativo : this.labels.lbl_status_desativado,
				};
				this.listSitesIAC.push(newIacOption);
			}
			this.isLoadingSites = false;
		});
	}

	//Desativar Site
	deactivateSite(id: string) {
		if (this.isUpdating || this.isDisabling) return;
		this.isDisabling = true;
		if (this.customInterface.id || this.customInterface.id != '')
			this.siteService.deactivateSite(this.customInterface).subscribe((data) => {
				if (data[0].status === 'error') {
					return this.notification.setNotificationMessage(this.labels.lbl_geral_site_nao_pode_ser_desativado);
				}
				this.getAllSites();
				this.isButtonVisible = 0;
				this.notification.setNotificationMessage(this.labels.lbl_geral_site_desativado);
				this.isLoadingSites = true;
				this.getAllSites();
				this.isDisabling = false;
			});
	}

	//Ativar Site
	activateSite(id: string) {
		if (this.isUpdating || this.isDisabling) return;
		this.isDisabling = true;

		this.siteService.activateSite(this.customInterface).subscribe((data) => {
			this.getAllSites();
			this.isButtonVisible = 1;
			this.notification.setNotificationMessage(this.labels.lbl_geral_site_ativado);
			this.isLoadingSites = true;
			this.getAllSites();
			this.isDisabling = false;
		});
	}
}
